import React, { useCallback, useEffect, useRef } from 'react';
import Icon from '../Icon/Icon';
import SearchIcon from '@jwp/ott-theme/assets/icons/search.svg?react';
import SearchSmall from '@jwp/ott-theme/assets/icons/Search-small.svg?react';
import SearchBar from '../SearchBar/SearchBar';

import styles from './ChannelSearchResults.module.scss';

interface ChannelSearchBarProps {
  searchActive: boolean;
  onSearchActiveChange: (active: boolean) => void;
  onQueryChange: (query: string) => void;
  searchQuery: string;
  collapseOnClose?: boolean;
}

const ChannelSearchBar: React.FC<ChannelSearchBarProps> = ({
  searchActive,
  onSearchActiveChange,
  onQueryChange,
  searchQuery,
  collapseOnClose = false,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null) as React.MutableRefObject<HTMLInputElement>;

  const handleSearchQueryChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const query = e.target.value.replace(/\s+/g, ' ').trimStart();
      onQueryChange(query); // ✅ Parent component handle aagum debounce
    },
    [onQueryChange]
  );

  const closeSearch = useCallback(() => {
    onQueryChange('');
    if (collapseOnClose) {
      onSearchActiveChange(false);
    }
  }, [collapseOnClose, onSearchActiveChange, onQueryChange]);

  useEffect(() => {
    if (searchActive && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [searchActive]);

  return searchActive ? (
    <div className={styles.searchContainer}>
      <SearchBar
        query={searchQuery}
        onQueryChange={handleSearchQueryChange}
        onClose={closeSearch}
        variant="compact"
        placeholder={true}
        containerClassName={styles.customSearchBar}
        inputRef={searchInputRef}
      />
    </div>
  ) : (
    <button
      type="button"
      className={styles.searchButton}
      aria-label="Search"
      onClick={() => onSearchActiveChange(true)}
    >
      <Icon icon={SearchSmall} />
    </button>
  );
};

export default ChannelSearchBar;